import _get from 'lodash/get';
import _head from 'lodash/head';
import _map from 'lodash/map';
import _keys from 'lodash/keys';
import _startCase from 'lodash/startCase';
import _orderBy from 'lodash/orderBy';

import moment from 'moment';

import initialState from './initialState';
import actionType from './actionTypes';

const gqlReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_SOURCE_RECORDS_SUCCESS:
            const key = action.payload.length > 0 ? _keys(action.payload[0]) : {};
            const columns = _keys(_head(_get(action.payload, key, [])));
            if (key.length > 0) {
                return {
                    ...state,
                    rowData: action.payload,
                    // _map(_orderBy(_get(action.payload, key, []), ['assttimestamp'], ['desc']), (props) => ({
                    //     ...props,
                    //     assttimestamp: moment.utc(new Date(parseInt(props.assttimestamp) * 1000)).format('YYYY-MM-DD HH:mm:ss'),
                    // })),
                    gridOptions: {
                        ...state.gridOptions,
                        columnDefs: _map(key, (column) => ({
                            headerName: _startCase(column),
                            field: column,
                            dataType: column,
                        })),
                    },
                };
            }
            return {
                ...state,
                rowData: [],
            };
        case actionType.GET_SOURCE_RECORDS_SUCCESS_FROM_IMMNU_DB:
            if (action.payload && action.payload.length > 0) {
                const newFormattedPayload = _map(action.payload, ({ value }) => ({ ...JSON.parse(value) }));
                const columns = _keys(newFormattedPayload[0]);
                console.log('newFormattedPayload', newFormattedPayload);
                return {
                    ...state,
                    rowData: _map(_orderBy(newFormattedPayload, ['timestamp'], ['desc']), (props) => ({
                        timestamp: moment.utc(new Date(parseInt(props.timestamp) * 1000)).format('YYYY-MM-DD HH:mm:ss'),
                        ...props,
                    })),
                    gridOptions: {
                        ...state.gridOptions,
                        columnDefs: _map(columns, (column) => ({
                            headerName: _startCase(column),
                            field: column,
                            dataType: column,
                        })),
                    },
                };
            }
            return {
                ...state,
                rowData: [],
            };
        case actionType.GET_SOURCE_RECORDS_FAILURE:
            return {
                ...state,
                rowData: [],
                gridOptions: {
                    ...state.gridOptions,
                    columnDefs: [],
                },
            };
        case actionType.GET_ALL_SCHEMA_NAMES_SUCCESS:
            return {
                ...state,
                schemaNames: action.payload,
            };
        case actionType.GET_RECON_GRAPH_SUMMARY:
            const keys = _keys(action.payload[0]);
            if (keys.length > 0) {
                return {
                    ...state,
                    rowData: action.payload,
                    gridOptions: {
                        ...state.gridOptions,
                        columnDefs: _map(keys, (column) => ({
                            headerName: _startCase(column),
                            field: column,
                            dataType: column,
                        })),
                    },
                };
            }
            return {
                ...state,
                rowData: [],
            };
        case actionType.GET_TRADE_EXPLORER_RECORDS_SUCCESS:
            return {
                ...state,
                agGridTrades: action.payload,
            };
        case actionType.GET_TRADE_HISTORY_RECORDS_SUCCESS:
            return {
                ...state,
                tradeHistoryRowData: _map(action.payload, (props) => ({
                    ...props,
                    tradeDate: moment(new Date(Math.floor(+props.tradeDate / 1000000))).format('yyyy-MM-DD HH:mm:ss'),
                })),
            };
        case actionType.GET_CHILD_HISTORY_RECORDS_SUCCESS:
            return {
                ...state,
                tradeChildHistoryRowData: _map(action.payload, (props) => ({
                    ...props,
                    tradeDate: moment(new Date(Math.floor(+props.tradeDate / 1000000))).format('yyyy-MM-DD HH:mm:ss'),
                })),
            };
        default:
            return state;
    }
};

export default gqlReducer;
